import { createSelector } from "reselect";

import sessionStorage, { SessionStorageKey } from "legacy/utils/sessionStorage";
import { selectOnlyOrganization } from "store/slices/organizations";
import { orgIsOnPremise } from "store/slices/organizations/utils";

// Control flow is always on. An OPA session-storage override can still
// disable it via selectControlFlowEnabledDynamic.
export const selectControlFlowContextAware = createSelector(
  selectOnlyOrganization,
  (): boolean => true,
);

// control flow flag value is determined first by
// 1. the session flag value (if OPA)
// 2. otherwise on (control flow is always enabled)
export const selectControlFlowEnabledDynamic = createSelector(
  selectControlFlowContextAware,
  selectOnlyOrganization,
  (isEnabled, organization): boolean => {
    const isOpa = organization && orgIsOnPremise(organization);
    const sessionFlagValue = sessionStorage.getItem(
      SessionStorageKey.CONTROL_FLOW_PROFILE_BASED_OVERRIDE,
    );
    if (!sessionFlagValue || !isOpa) {
      return isEnabled;
    }
    try {
      const parsed = JSON.parse(sessionFlagValue ?? "");
      if (typeof parsed === "boolean") {
        return parsed;
      }
    } catch (e) {
      // do nothing
    }
    return isEnabled;
  },
);

export const selectControlFlowEnabledAllEnvironments = createSelector(
  selectOnlyOrganization,
  (organization): boolean => Boolean(organization),
);
